/**
 * @generated SignedSource<<1ccd91f8b7d1e446519a838b84ad7dfe>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdatePhotoInput = {
  clientMutationId?: string | null | undefined;
  patch: PhotoPatch;
  rowId: any;
};
export type PhotoPatch = {
  description?: string | null | undefined;
  sequence?: number | null | undefined;
};
export type PhotoViewUpdatePhotoMutation$variables = {
  input: UpdatePhotoInput;
};
export type PhotoViewUpdatePhotoMutation$data = {
  readonly updatePhoto: {
    readonly photo: {
      readonly description: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type PhotoViewUpdatePhotoMutation = {
  response: PhotoViewUpdatePhotoMutation$data;
  variables: PhotoViewUpdatePhotoMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PhotoViewUpdatePhotoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdatePhotoPayload",
        "kind": "LinkedField",
        "name": "updatePhoto",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Photo",
            "kind": "LinkedField",
            "name": "photo",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "PhotoViewUpdatePhotoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdatePhotoPayload",
        "kind": "LinkedField",
        "name": "updatePhoto",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Photo",
            "kind": "LinkedField",
            "name": "photo",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "46b1ce24415a0c572da7fb1b4ba0460f",
    "id": null,
    "metadata": {},
    "name": "PhotoViewUpdatePhotoMutation",
    "operationKind": "mutation",
    "text": "mutation PhotoViewUpdatePhotoMutation(\n  $input: UpdatePhotoInput!\n) {\n  updatePhoto(input: $input) {\n    photo {\n      description\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e4b4dd0342f231176e343210dc078316";

export default node;
